import { Store } from '@ngrx/store';
import { Injectable } from '@angular/core';

import { CookieService } from 'ngx-cookie-service';
import {
  AppStatePartialState,
  APPSTATE_FEATURE_KEY,
  AppState,
} from './appstate.reducer';
import * as fromAppstateActions from './appstate.actions';
import { AppstateService } from './appstate.service';
import {
  Observable,
  of,
  firstValueFrom,
  Subject,
  takeUntil,
  catchError,
} from 'rxjs';
// eslint-disable-next-line @nx/enforce-module-boundaries
import { take } from 'rxjs/internal/operators/take';
import { MatDialog } from '@angular/material/dialog';
// eslint-disable-next-line @nx/enforce-module-boundaries
import { MatAlertDialogComponent } from '@cigna/cigna-for-brokers/shared/ui';
import { AppstateFacade } from './appstate.facade';
// eslint-disable-next-line @nx/enforce-module-boundaries
import { FeatureTogglesFacade } from '@cigna/shared/angular/features-feature';

@Injectable()
export class ProfileResolver {
  isOktaEnabled = false;
  isInternalUser: string;
  isFromBRPortal: string;
  profileData$ = this.appstateFacade.isProfileUser$;
  isOktaLoginEnabled$ = this.featureTogglesFacade.featuresEnabled([
    'isOktaLoginEnabled',
  ]);
  private _ngUnsubscribe$: Subject<void> = new Subject<void>();
  operatorId: unknown;
  constructor(
    private dialog: MatDialog,
    private cookieService: CookieService,
    private apiService: AppstateService,
    private store$: Store<AppStatePartialState>,
    private appstateFacade: AppstateFacade,
    private featureTogglesFacade: FeatureTogglesFacade,
  ) {
    this.isInternalUser = this.cookieService.get('is-crp-internal');
    this.isFromBRPortal = this.cookieService.get('is-broker');
    this.isOktaLoginEnabled$
      .pipe(takeUntil(this._ngUnsubscribe$))
      .subscribe((isFeatureToggleEnabled) => {
        this.isOktaEnabled = isFeatureToggleEnabled;
      });
    this.profileData$.pipe(takeUntil(this._ngUnsubscribe$)).subscribe((res) => {
      if (res) {
        this.operatorId = res.accessTokenBody['agent.operatorId'];
        this.operatorId = res.accessTokenBody['agent.operatorId'];
        const isLastLoginUpdated = localStorage.getItem('isLastLoginUpdated');
        if (
          !this.operatorId &&
          !isLastLoginUpdated &&
          !this.isOktaEnabled &&
          (!this.isInternalUser || this.isInternalUser === 'false')
        ) {
          this.updateUserLoginTime();
        }
      }
    });
  }

  resolve(): Observable<AppState> {
    if (!this.isInternalUser || this.isInternalUser === 'false') {
      this.initWelcomeData();
      this.initBusinessAlertData();
    }
    if (this.isFromBRPortal !== 'true') {
      this.cookieService.delete('is-broker', '/');
    }
    return this.waitForProfileDataToLoad();
  }

  waitForProfileDataToLoad(): Observable<AppState> {
    this.store$.select('appstate').subscribe((appstateData) => {
      if (appstateData.navigation) {
        return of(appstateData.navigation);
      }
      if (appstateData.brNavigation && this.isFromBRPortal === 'true') {
        return of(appstateData.brNavigation);
      }
    });
    return this.store$.select('appstate').pipe(take(1));
  }

  initWelcomeData(): void {
    this.store$.pipe(take(1)).subscribe((store) => {
      if (!store[APPSTATE_FEATURE_KEY].navigation) {
        firstValueFrom(this.apiService.getWelcomeTile()).then((data) => {
          if (data.contentType !== null) {
            this.store$.dispatch(
              fromAppstateActions.getWelcomeTileSuccess({
                payload: data,
              }),
            );
          } else {
            this.openNoActiveCls();
          }
        });
      }
    });
  }

  initBusinessAlertData(): void {
    this.store$.pipe(take(1)).subscribe((store) => {
      if (!store[APPSTATE_FEATURE_KEY].navigation) {
        firstValueFrom(this.apiService.getInstantAlertData()).then((data) => {
          if (data !== null) {
            this.store$.dispatch(
              fromAppstateActions.getBusinessAlertsSuccess({
                payload: data,
              }),
            );
          } else {
            this.openNoActiveCls();
          }
        });
      }
    });
  }

  updateUserLoginTime(): void {
    this.apiService
      .updateUserLoginTime()
      .pipe(catchError((error) => of(console.error('Error', error))))
      .subscribe(() => {
        localStorage.setItem('isLastLoginUpdated', 'true');
      });
  }

  openNoActiveCls(): void {
    this.dialog.open(MatAlertDialogComponent, {
      autoFocus: false,
      disableClose: true,
      minWidth: '700px',
      data: {
        heading: 'global.err',
        message: 'global.noActiveClient',
        buttonText: 'global.ok',
      },
    });
  }
}
